{
  "EnablerptrequestauditLabel": "Berichtsanforderungs-Audit-Ausgabe aktivieren:",
  "Audit_SectionHeader": "Prüfung",
  "Audit_SectionPara": "Warnung: Aktivieren Sie die folgende Einstellung nur, wenn Sie von einem Mitglied Ihrer Anwendungsverwaltung oder Ihres Support-Teams dazu aufgefordert werden.",
  "NAME": "Audit"
}